import {React, useState} from "react";
import styled from "styled-components";
import ChatContainer from "../components/ChatContainer";
import chatIcon from "./../assets/chat.png";
import chatCloseIcon from "./../assets/close.png";
import logoFav from "./../assets/logo-fav.png";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

// TEMPORARY: chatbot is off while we migrate off the retired OpenAI Assistants
// API. Set to false, rebuild and redeploy to restore it. Admin links from
// /all-messages and /all-reviews (?user=admin) stay working so past
// conversations and ratings are still readable.
const CHATBOT_DISABLED = true;

export default function HomeScreen() {
  
  const[showChat, setShowChat] = useState(true);

  const chatClickFunc = () => {
    if(showChat==true){
      setShowChat(false);
    }else {
      setShowChat(true);
    }
  }

  const isAdmin =
    new URLSearchParams(window.location.search).get("user") === "admin";

  const closeWindow = () => window.parent.postMessage({ action: "closeIframe" }, "*");

  if (CHATBOT_DISABLED && !isAdmin) {
    return (
      <NoticeContainer>
        <div className="notice-header">
          <img src={logoFav} className="logoFav" alt="GM Lighting" />
          <h3>GM Lighting</h3>
          {window.parent !== window && (
            <div className="close-btn" onClick={closeWindow} aria-label="Close">
              <KeyboardArrowDownIcon />
            </div>
          )}
        </div>
        <div className="notice-body">
          <h2>Our AI assistant is temporarily unavailable..</h2>
          <p>We are upgrading it and expect to be back shortly.</p>
          {/* <p>
            For product help, contact{" "}
            <a href="mailto:sales@gmlighting.net">sales@gmlighting.net</a> or
            call <a href="tel:8666710811">(866) 671-0811</a>.
          </p> */}
        </div>
      </NoticeContainer>
    );
  }
  
  return (
    <>
      <Container>
        <div className="container">
            <ChatContainer />
        </div>
      </Container>
    </>
  );
}

const NoticeContainer = styled.div`
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: grid;
  grid-template-rows: 60px 1fr;
  background-color: #ffffff;
  overflow: hidden;

  .notice-header {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 0 1rem;
    background-color: #131324;
    .logoFav { cursor: default; }
    h3 { color: #ffffff; font-size: 1rem; font-weight: 500; }
    .close-btn {
      margin-left: auto;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 30px;
      width: 30px;
      border-radius: 0.5rem;
      background-color: #87b048;
      color: #ffffff;
      cursor: pointer;
    }
  }

  .notice-body {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 1.5rem;
    overflow-y: auto;
    text-align: center;
    color: #2b2b2b;
    h2 { font-size: 1.05rem; margin-bottom: 0.75rem; }
    p { font-size: 0.875rem; line-height: 1.6; margin-bottom: 0.75rem; }
    a { color: #87b048; font-weight: 600; text-decoration: none; }
  }
`;

const Container = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1rem;
  align-items: center;
  background-color: #131324;
  // .container {
  //   height: 85vh;
  //   width: 85vw;
  //   background-color: #00000076;
  //   display: grid;
   
  // }
`;
